import {formatMedianDuration, formatPct} from './totalsFormatting';
import type {TicketGroupStats} from './groupTickets';

/**
 * How a group's subtotals read in its header.
 *
 * A group header is the table's totals row scoped to one bucket, so the two go
 * through the same formatters: a reader comparing "42% resolved" in a header
 * against the totals row above it must be seeing the same rounding and the same
 * duration units. `totalsFormatting` owns those; this module only adds the count's
 * wording, which is the one thing a header says differently ("7 tickets" rather
 * than the totals row's bare figure under a "Total" label).
 */

export function formatResolvedRatio(ratio: number | null): string {
	return formatPct(ratio);
}

export function formatMedianResolution(seconds: number | null): string {
	return formatMedianDuration(seconds);
}

export function formatGroupCount(count: number): string {
	return `${count} ${count === 1 ? 'ticket' : 'tickets'}`;
}

/** The three subtotals PRD §6.7 puts on a group header, in reading order. */
export function groupSubtotals(stats: TicketGroupStats): {count: string; resolved: string; median: string} {
	return {
		count: formatGroupCount(stats.count),
		resolved: formatResolvedRatio(stats.resolvedRatio),
		median: formatMedianResolution(stats.medianResolutionSeconds),
	};
}
